import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import axiosInstance from '../configs/axios';

export const getUserIp = createAsyncThunk('appProIp/getUserIp', async () => {
  return axiosInstance
    .get('/user/getIp')
    .then((res) => {
      const { data } = res.data;
      return { success: true, data };
    })
    .catch(() => {
      return { success: false, data: 'something wrong' };
    });
});

export const appPlanSlice = createSlice({
  name: 'appProIp',
  initialState: {
    data: [],
  },
  reducers: {},
});

export default appPlanSlice.reducer;
